import React from 'react';
import { Link } from 'react-router-dom';

function Servicos() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="text-white mb-4 text-center">
          <i className="bi bi-tools me-2 text-warning"></i>Nossos Serviços
        </h2>

        <ul className="list-unstyled fs-6">
          <li className="mb-4">
            <i className="bi bi-hdd-network me-2 text-info"></i>
            <strong>Infraestrutura de Rede:</strong> 
            Soluções completas em cabeamento estruturado, racks, switches gerenciáveis, servidores físicos e virtuais, com alta performance e segurança.
          </li>

          <li className="mb-4">
            <i className="bi bi-shield-lock me-2 text-warning"></i>
            <strong>Segurança da Informação:</strong> 
            Implantação de firewalls de próxima geração, antivírus corporativo, gestão de vulnerabilidades e proteção de dados com políticas de acesso.
          </li>

          <li className="mb-4">
            <i className="bi bi-cloud-check me-2 text-primary"></i>
            <strong>Cloud e Hospedagem:</strong> 
            Hospedagem segura em nuvem, e-mails corporativos, backup automático e soluções escaláveis com alta disponibilidade.
          </li>

          <li className="mb-4">
            <i className="bi bi-person-badge me-2 text-success"></i>
            <strong>LGPD:</strong> 
            Consultoria em proteção de dados, adequação legal da sua empresa à Lei Geral de Proteção de Dados, com análise de riscos e plano de conformidade.
          </li>

          <li className="mb-4">
            <i className="bi bi-headset me-2 text-light"></i>
            <strong>Suporte Técnico:</strong> 
            Atendimento remoto e presencial, manutenção preventiva e corretiva, com equipe técnica altamente capacitada.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-warning btn-lg px-4">
            Fale com um especialista
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Servicos;
